import { render } from "./blogBannerComponent.vue?vue&type=template&id=483018a8&scoped=true"
import script from "./blogBannerComponent.vue?vue&type=script&lang=js"
export * from "./blogBannerComponent.vue?vue&type=script&lang=js"

import "./blogBannerComponent.vue?vue&type=style&index=0&id=483018a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483018a8"]])

export default __exports__